/* eslint-disable */
import React, { Component } from 'react';
import {browserHistory} from 'react-router';
import moment from 'moment';
import FormCommonFields from './FormCommonFields';
import AddressLookup from '../../commons/AddressLookup/AddressLookup';
import axios from 'axios';
import appConfig from '../../../config';
import {DateField, Checkbox} from '../../commons/Inputs';

let $ = window.jQuery;
let signaturePad = window.signaturePad;

import NotificationSystem from 'react-notification-system';

export default class PatientInfo extends Component {

	state = {
		patientId : '',
		media_id : '',
		signatureSource : '/images/medix_white_logo.png',
		patientData : [],

		entry_date : moment().format('MMMM DD, YYYY'),
		firstname : '',
		middlename : '',
		lastname : '',
		gender : '',
		civil_status : '',
		birthdate : moment(),
		religion_id : '',
		contact_no : [{'number':'','phone_type_id': 1}],
		contact_type : '',
		email_address : [{email:'', email_type_id : 1}],
		email_type : '',

		street : '',
		barangay : '',
		city : '',
		province : '',
		zip_code : '',
		

		nationality_id : '',
		position : '',
		office_name : '',
		office_number : '',
		office_address : '',
		dental_insurance : '',
		effective_date : '',
		note : '',
		referrer : '',
		reason_consultation : '',
		nationalities : [],
		emergency_contacts: []
	}

	getPatients = () => {

		let url = appConfig.apiUrl + 'dental/patients/' + this.props.storeParams.patientId;
		// console.log(this.props.params.patientId);

		axios({
			url: url,
			method: 'get',
			responseType: 'json',
		}).then((response) => {
			let user = response.data.data.user;
			
			this.setState({
				patientData : response.data.data,				
	        	nationality_id : user.nationality ? user.nationality : '',
	        	position : user.occupations.length > 0 ? user.occupations[0].position : '',
	        	entry_date : user.dental.length > 0 ? moment(user.dental[0].entry_date).format('MMMM DD, YYYY') : moment(data.created_at).format('MMMM DD, YYYY'),
	        	firstname : user.firstname,
	        	middlename : user.middlename ? user.middlename : '',
	        	lastname : user.lastname,
	        	gender : user.gender,
	        	civil_status : user.civil_status ? user.civil_status : '',
	        	birthdate : user.birthdate ? moment(user.birthdate) : '',
	        	religion_id : user.religion_id,
	        	contact_no : user.user_phone_numbers.length > 0 ? user.user_phone_numbers : [{'number':'','phone_type_id': 1}],
	        	contact_type : user.user_phone_numbers.length > 0 ? user.user_phone_numbers[0].phone_number_type_id : '',
	        	email_address : user.user_emails.length > 0 ? user.user_emails : [{'email':''}],

	        	street : user.user_addresses.length > 0 ? user.user_addresses[0].street : '',
	        	barangay : user.user_addresses.length > 0 ? user.user_addresses[0].barangay : '',
	        	city : user.user_addresses.length > 0 ? user.user_addresses[0].municipality : '',
	        	province : user.user_addresses.length > 0 ? user.user_addresses[0].province : '',
	        	zip_code : user.user_addresses.length > 0 ? user.user_addresses[0].zip_code : '',

	        	office_name : user.occupations.length > 0 ? user.occupations[0].office_name : '',
	        	office_number : user.occupations.length > 0 ? user.occupations[0].office_number : '',
	        	office_address : user.occupations.length > 0 ? user.occupations[0].office_address : '',
	        	dental_insurance : user.insurances.length > 0 ? user.insurances[0].dental_insurance : '',
	        	effective_date : user.insurances.length > 0 ? moment(user.insurances[0].effective_date).format('MMMM DD, YYYY') : '',
	        	note : user.insurances.length > 0 ? user.insurances[0].note : '',
	        	referrer : user.dental.length > 0 ? user.dental[0].referrer : '',
	        	reason_consultation : user.dental.length > 0 ? user.dental[0].reason_consultation : '',
	        	emergency_contacts : user.user_emergency_contacts.length > 0 ? user.user_emergency_contacts : []
	        }, () => {
	        	// console.log(this.state);
	        });

			this.getSignature(response.data.data);

		}).catch(function (error) {
			
		});

		// let user = data.user;
		
		// // console.log(user);
		// this.setState({
			
  //       	nationality_id : user.nationality ? user.nationality : '',
  //       	position : user.occupations.length > 0 ? user.occupations[0].position : '',
  //       	entry_date : user.dental.length > 0 ? moment(user.dental[0].entry_date).format('MMMM DD, YYYY') : moment(data.created_at).format('MMMM DD, YYYY'),
  //       	firstname : user.firstname,
  //       	middlename : user.middlename ? user.middlename : '',
  //       	lastname : user.lastname,
  //       	gender : user.gender,
  //       	civil_status : user.civil_status ? user.civil_status : '',
  //       	birthdate : user.birthdate ? moment(user.birthdate) : '',
  //       	religion_id : user.religion_id,
  //       	contact_no : user.user_phone_numbers.length > 0 ? user.user_phone_numbers : [{'number':'','phone_type_id': 1}],
  //       	contact_type : user.user_phone_numbers.length > 0 ? user.user_phone_numbers[0].phone_number_type_id : '',
  //       	email_address : user.user_emails.length > 0 ? user.user_emails : [{'email':''}],

  //       	street : user.user_addresses.length > 0 ? user.user_addresses[0].street : '',
  //       	barangay : user.user_addresses.length > 0 ? user.user_addresses[0].barangay : '',
  //       	city : user.user_addresses.length > 0 ? user.user_addresses[0].municipality : '',
  //       	province : user.user_addresses.length > 0 ? user.user_addresses[0].province : '',
  //       	zip_code : user.user_addresses.length > 0 ? user.user_addresses[0].zip_code : '',

  //       	office_name : user.occupations.length > 0 ? user.occupations[0].office_name : '',
  //       	office_number : user.occupations.length > 0 ? user.occupations[0].office_number : '',
  //       	office_address : user.occupations.length > 0 ? user.occupations[0].office_address : '',
  //       	dental_insurance : user.insurances.length > 0 ? user.insurances[0].dental_insurance : '',
  //       	effective_date : user.insurances.length > 0 ? moment(user.insurances[0].effective_date).format('MMMM DD, YYYY') : '',
  //       	note : user.insurances.length > 0 ? user.insurances[0].note : '',
  //       	referrer : user.dental.length > 0 ? user.dental[0].referrer : '',
  //       	reason_consultation : user.dental.length > 0 ? user.dental[0].reason_consultation : ''
  //       }, () => {
  //       	// console.log(this.state);
  //       });
	}

	submitPatientForm = (e) => {
		e.persist(); //Event pooling

		// disabled button
		$(e.target).addClass('disabled');

		let form = $('#patientInfoForm');
		let data = form.serialize();
		let url = appConfig.apiUrl + 'dental/patients';
		let method = 'POST';
		
		// form validation
		if(this.formValidation() != true)
		{
			$(e.target).removeClass('disabled');
			return;
		}

		if(this.state.patientId)
		{
			// data += '&_method=PUT';
			url = appConfig.apiUrl + 'dental/patients/' + this.state.patientId;
			
			axios.put(url, data).then((response) => {
				// console.log(response);
				let user = response.data.data.user;

				this.setState({
			
		        	nationality_id : user.nationality ? user.nationality : '',
		        	position : user.occupations.length > 0 ? user.occupations[0].position : '',
		        	entry_date : user.dental.length > 0 ? moment(user.dental[0].entry_date).format('MMMM DD, YYYY') : moment(data.created_at).format('MMMM DD, YYYY'),
		        	firstname : user.firstname,
		        	middlename : user.middlename ? user.middlename : '',
		        	lastname : user.lastname,
		        	gender : user.gender,
		        	civil_status : user.civil_status ? user.civil_status : '',
		        	birthdate : user.birthdate ? moment(user.birthdate) : '',
		        	religion_id : user.religion_id,
		        	contact_no : user.user_phone_numbers.length > 0 ? user.user_phone_numbers : [{'number':'','phone_type_id': 1}],
		        	contact_type : user.user_phone_numbers.length > 0 ? user.user_phone_numbers[0].phone_number_type_id : '',
		        	email_address : user.user_emails.length > 0 ? user.user_emails : [{'email':''}],

		        	street : user.user_addresses.length > 0 ? user.user_addresses[0].street : '',
		        	barangay : user.user_addresses.length > 0 ? user.user_addresses[0].barangay : '',
		        	city : user.user_addresses.length > 0 ? user.user_addresses[0].municipality : '',
		        	province : user.user_addresses.length > 0 ? user.user_addresses[0].province : '',
		        	zip_code : user.user_addresses.length > 0 ? user.user_addresses[0].zip_code : '',

		        	office_name : user.occupations.length > 0 ? user.occupations[0].office_name : '',
		        	office_number : user.occupations.length > 0 ? user.occupations[0].office_number : '',
		        	office_address : user.occupations.length > 0 ? user.occupations[0].office_address : '',
		        	dental_insurance : user.insurances.length > 0 ? user.insurances[0].dental_insurance : '',
		        	effective_date : user.insurances.length > 0 ? moment(user.insurances[0].effective_date).format('MMMM DD, YYYY') : '',
		        	note : user.insurances.length > 0 ? user.insurances[0].note : '',
		        	referrer : user.dental.length > 0 ? user.dental[0].referrer : '',
		        	reason_consultation : user.dental.length > 0 ? user.dental[0].reason_consultation : ''
		        }, () => {
		        	this.showSuccessNotification();
		        	this.props.onUpdatePatientInfo();
		        });

	        	
	        	// enabled button
	            $(e.target).removeClass('disabled');
	            
	            // redirect to patient info
	            if(!this.state.patientId)
				{	
	            	browserHistory.push('/patients/' + response.data.data.id);
	            }

	            this.props.getPatient();
			}).catch((error)=> {

			});

			return;
		}

		axios.post(url,data).then((response) => {
        	// console.log(response);
        	this.showSuccessNotification();
        	
        	// enabled button
            $(e.target).removeClass('disabled');
            
            // redirect to patient info
            if(!this.state.patientId)
			{	
            	browserHistory.push('/patients/' + response.data.data.id);
            }
        }).catch(function (error) {

        });
	}

	formValidation = () => {
		let firstname = $('#firstname_field');
		let lastname = $('#lastname_field');
		let gender = $('#gender_field');
		let civil_status = $('#civil_status_field');
		let birthdate = $('#birthdate_field');
		let contact_no = $('#contact_no_field');
		let street = $('#street_field');
		let barngay = $('#add_district_name_params');
		let city = $('#add_city_name_params');
		let province = $('#add_province_name_params');
		let zip_code = $('#add_zip_name');

		if(firstname.val().trim() == '')
		{
			firstname.parent().addClass('has-error');
			firstname.focus();
			return false;
		}

		if(lastname.val().trim() == '')
		{
			lastname.parent().addClass('has-error');
			lastname.focus();
			return false;
		}

		if(gender.val().trim() == '')
		{
			gender.parent().addClass('has-error');
			gender.focus();
			return false;
		}
		
		if(civil_status.val() == '')
		{
			civil_status.parent().addClass('has-error');
			civil_status.focus();
			return false;
		}
		
		if(birthdate.val() == '')
		{
			birthdate.parent().addClass('has-error');
			birthdate.focus();
			return false;
		}

		// if(contact_no.val().trim() == '')
		// {
		// 	contact_no.parent().addClass('has-error');
		// 	contact_no.focus();
		// 	return false;
		// }

		return true
	}

	clickHandler = (e) => {
		this.submitPatientForm(e);
	}

	componentDidMount() {

		if(Object.keys(this.props.storeParams).length >= 0)
		{
			this.getPatients();
		}

		let wrapper = document.getElementById("signature_pad-body-mic"),
		    canvas = wrapper.querySelector("canvas");

		$('#signatureModal').on('shown.bs.modal', () => {
			this.resizeCanvas(canvas,wrapper);
		});
		
		$(window).on('resize', () => {
			this.resizeCanvas(canvas,wrapper);
		})
		

		signaturePad = new SignaturePad(canvas);

		/*initialize typeahead*/
		$('.nationalities_typeahead').typeahead(null, {
			display : 'nationality',
          	source: this.state.nationalities,
            templates: {
                empty: Handlebars.compile([
                    '<div class="empty-message" style="font-size: 13px; color: #000; padding: 10px;">',
                    'Unable to find any nationality that match the current search query',
                    '</div>'
                ].join('\n')),
                suggestion: Handlebars.compile([
                    '<div class="media">',
                        '<div class="media-body">',
                            '<h4 class="media-heading">{{nationality}}</h4>',
                        '</div>',
                    '</div>'
                ].join(''))
            }
        }).on('typeahead:selected', (obj, datum) => {
        	
        }).on('typeahead:active', (e) => {
            $(e.target).siblings('.form-control-focus').remove();
            $(e.target).siblings('.help-block').remove();
            $(e.target).parent().append('<div class="form-control-focus"></div><span class="help-block">Nationality Search</span>');
        });
	}

	componentWillReceiveProps(nextProps) {
		
		/*get patient ID from url parameter*/
		
		$(window).scrollTop(0);
		this.setState({patientId : this.props.storeParams.patientId});
		// if (nextProps.patientData === this.props.patientData) {
		// 	if (nextProps.patientData) {
		// 		if(Object.keys(nextProps.patientData).length > 0 && this.props.storeParams.patientId) {
		// 			this.setState({patientId : this.props.storeParams.patientId});
		// 			// this.getPatients(nextProps.patientData);
		// 			// this.getSignature(nextProps.patientData);

		// 			//console.log('patient data', nextProps.patientData === this.props.patientData);
		// 		}
		// 	}
		// }

	}

	componentWillMount() {
		

		var nationalities = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: appConfig.apiUrl + 'nationality/autocomplete?term=%QUERY',
                filter: function(response) {      
			    	return response.data;
			    },
                wildcard: '%QUERY'
            }
        });

        this.setState({nationalities});
	}

	showSuccessNotification = () => {
        // let notificationSystem = this.refs.notificationSystem;
        
        // notificationSystem.addNotification({
        //     title: 'Saved! Successfully',
        //     message: 'Patient Successfully Saved!',
        //     level: 'success',
        //     position : 'br',
        //     autoDismiss : 1
        // });

        App.alert({
        	type: 'info',
        	container : $('#alertNotif'),
        	message: 'Saved Succesfully!',
        	reset: true,
        	focus: false,
        	close: false,	
        	closeInSeconds: 1})
    };

    catchState = (data) => {
    	
    	this.setState(data,() => {}); // set state passing object
    }

    onCheckConsent = (e) => {
    	if(!e.target.checked)
    	{
    		signaturePad.clear();
    		return;
    	}
    	$('#signatureModal').modal('show');
    }

    resizeCanvas = (canvas,wrapper) => {
    	let ratio =  Math.max(window.devicePixelRatio || 1, 1);
    	canvas.width = $('#signatureModal .modal-body').width();
    	canvas.height = 300;
    }

    onClearSignature = () => {
    	signaturePad.clear();
    }

    onSaveSignature = () => {
    	if(signaturePad.isEmpty())
    	{
    		alert("Please provide signature first.");
    		return;
    	}
    	
    	let data = {
    		user_id : this.state.patientData.user_id,
    		signature : signaturePad.toDataURL()
    	};

    	let url = appConfig.apiUrl + 'signature';

    	axios.post(url,data).then((response) => {
        	
        	this.setState({signatureSource : signaturePad.toDataURL()});
    		$('#signatureModal').modal('hide');

        }).catch(function (error) {

        });
    }

    getSignature = (data) => {
    	let url = appConfig.apiUrl + 'signature/' + data.user_id;

    	axios.get(url).then((response) => {
    		// console.log(response);
    		// if(response.data.data.length > 0)
    		// {
    			this.setState({signatureSource : response.data.data.signature});	
    		// }
    		
        }).catch(function (error) {

        });
    }

	render () {

		let data = this.state;
		
		return (
			<div>
			<form role="form" id="patientInfoForm">

				<NotificationSystem ref="notificationSystem" sty />

				<input type="hidden" name="media_id" id="media_id" />
				<input type="hidden" name="patient_id" id="patient_id" value={this.state.patientId} onChange={(e) => {this.setState({patientId : e.target.value})}} />
				
				<FormCommonFields data={data} getState={this.catchState} />
	            
	            <hr/>

	            <AddressLookup data={data} getState={this.catchState} />
	            
	            <div className="form-group">
                    <div className="row">
	                	<div className="col-md-6">
		                	<div className="form-group form-md-line-input">
		                		<label className="control-label">Nationality</label>
			                    <input type="text" className="form-control nationalities_typeahead" name="nationality_id" value={this.state.nationality_id} onChange={(e) => {this.setState({nationality_id : e.target.value})}} /> 
		                	</div>
	                	</div>
	                </div>
	            </div>
	            <div className="form-group">
		            <div className="row">
		            	<div className="col-md-12">
		            		<label><strong>OCCUPATION</strong></label>
		            	</div>
		            </div>
                    <div className="row">
	                	<div className="col-md-4">
		                	<div className="form-group form-md-line-input">
			                    <input type="text" className="form-control" name="position" value={this.state.position} onChange={(e) => {this.setState({position : e.target.value})}} /> 
		                		<label className="control-label">Position</label>
		                	</div>
	                	</div>

	                	<div className="col-md-4">
		                	<div className="form-group form-md-line-input">
			                    <input type="text" className="form-control" name="office_name" value={this.state.office_name} onChange={(e) => {this.setState({office_name : e.target.value})}} /> 
		                		<label className="control-label">Office Name</label>
		                	</div>
	                	</div>
	                	<div className="col-md-4">
		                	<div className="form-group form-md-line-input">
			                    <input type="text" className="form-control" name="office_number" value={this.state.office_number} onChange={(e) => {this.setState({office_number : e.target.value})}} /> 
		                		<label className="control-label">Office Number</label>
		                	</div>
	                	</div>
	                </div>
	            </div>
	            <div className="form-group">
                    <div className="row">
	                	<div className="col-md-12">
		                	<div className="form-group form-md-line-input">
			                    <textarea rows="2" className="form-control" name="office_address" value={this.state.office_address} onChange={(e) => {this.setState({office_address : e.target.value})}} /> 
		                		<label className="control-label">Office Address</label>
		                	</div>
	                	</div>
	                </div>
	            </div>
	            <hr/>
	            <div className="form-group">
	            	<div className="row">
	                	<div className="col-md-12">
	                		<label className="control-label"><strong>Insurance</strong></label>
	                	</div>
	                </div>

                    <div className="row">
	                	<div className="col-md-6">
		                	<div className="form-group form-md-line-input">
			                    <input type="text" className="form-control" name="dental_insurance" value={this.state.dental_insurance} onChange={(e) => {this.setState({dental_insurance : e.target.value})}} /> 
		                		<label className="control-label">Dental Insurance</label>
		                	</div>
	                	</div>
	                	<div className="col-md-6">
		                	<DateField val={this.state.effective_date} readonly={true} id="effective_date" label="Effective Date" help="" onChange={(e) => {this.setState({effective_date : e.target.value})}}/>
	                	</div>
	                </div>
	            </div>
	            <div className="form-group">
                    <div className="row">
	                	<div className="col-md-12">
		                	<div className="form-group form-md-line-input">
			                    <textarea rows="patient_insurance_notes" className="form-control" name="note" value={this.state.note} onChange={(e) => {this.setState({note : e.target.value})}} /> 
		                		<label className="control-label">Note</label>
		                	</div>
	                	</div>
	                </div>
	            </div>
	            <hr/>
	            <div className="form-group">
	            	<div className="row">
		            	<div className="col-md-12">
		            		<label><strong>OTHERS</strong></label>
		            	</div>
		            </div>
                    <div className="row">
	                	<div className="col-md-12">
		                	<div className="form-group form-md-line-input">
			                    <input type="text" className="form-control" name="referrer" value={this.state.referrer} onChange={(e) => {this.setState({referrer : e.target.value})}} /> 
		                		<label className="control-label">Whom may we thank for referring you?</label>
		                	</div>
	                	</div>
	                </div>
	            </div>
	            <div className="form-group">
                    <div className="row">
	                	<div className="col-md-12">
		                	<div className="form-group form-md-line-input">
			                    <textarea rows="2" className="form-control" name="reason_consultation" value={this.state.reason_consultation} onChange={(e) => {this.setState({reason_consultation : e.target.value})}} /> 
		                		<label className="control-label">What is your reason for dental consultation?</label>
		                	</div>
	                	</div>
	                </div>
	            </div>
	            
	            {this.state.patientId ?
		            
		            <div>
						<h2 style={{}}>Terms and Condition</h2>
						<div className="terms" style={{ width: '100%', height: '250px', overflowY: 'scroll', border: '1px solid #ddd', padding: '20px 10px' }}>
							<p>
								<strong>TREATMENT TO BE DONE:</strong> I understand and consent to have any treatment done by the dentist after the procedure,
								the risks & benefits & cost have been fully explained. These treatments include, but are not limited to, x-rays, cleansing,
								periodontal treatments, fillings, crowns, bridges, all types of extraction, root canals, &/or dentures, local anesthetics &
								surgical cases.
							</p>

							<p>
								<strong>DRUGS & MEDICATIONS:</strong> I understand that antibiotics, analgesics & other medications can cause allergic reactions like
								redness & swelling of tissues, pain, itching, vomiting, &/or anaphylactic shock.
							</p>

							<p>
								<strong>CHANGES IN TREATMENT PLAN:</strong> I understand that during treatment if may be necessary to change/add procedures
								because of conditions found while working on the teeth that was not discovered during examination. For example, root canal
								therapy may be needed following routine restorative procedures. I give my permission to the dentist to make any/all
								changes and additions as necessary with my responsibility to pay all the costs agreed.
							</p>

							<p>
								<strong>RADIOGRAPH:</strong> I understand that an x-ray shot or a radiography maybe necessary as part of diagnostic aid to come up
								with tentative diagnostic of my Dental problem and to make a good treatment plan, but, this will not give me a 100%
								assurance for the accuracy of the treatment since all dental treatments are subject to unpredictable complications that later
								on may lead to sudden changes and additions as necessary with my responsibility to pay all the costs agreed.
							</p>

							<p>
								<strong>REMOVAL OF TEETH:</strong> I understand that alternatives to tooth removal (root canal therapy, crown & periodontal surgery,
								etc.) & I completely understand these alternatives, including their risk & benefits prior to authorizing the dentist to remove
								teeth & any other structures necessary for reasons above. I understand that removing teeth does not always remove all the
								infections, if present, & it may be necessary to have further treatment. I understand the risk involved in having teeth
								remove, such as pain swelling, spread of infection, dry socket, fractured jaw, loss of feeling of the teeth, lips, tongue &
								surrounding tissue that can last for an indefinite period of time. I understand that I may need further treatment under a
								specialist if complications arise during or following treatment.
							</p>

							<p>
								<strong>CROWNS (CAPS) & BRIDGES:</strong> Preparing a tooth may irritate the nerve tissue in the center of the tooth, leaving the
								tooth extra sensitive to heat, cold & pressure. Treating such irritation may involve using special toothpastes, mouth rinses or
								root canal therapy. I understand that sometimes it is not possible to match the color of natural teeth exactly with artificial
								teeth. I further understand that I may be wearing temporary crowns, which may come off easily & that I must be careful to
								ensure that they are kept on until the permanent crowns are delivered. It is my responsibility to return for permanent
								cementation within 20 days from tooth preparation, as excessive days delay may allow for tooth movement, which may
								necessiate a remake of the crown, bridge/ cap. I understand there will be additional charges for remakes due to my delaying
								of permanent cementation, & I realize that final opportunity to make changes in my new crown, bridge or cap (including
								shape, fit, size & color) will be before permanent cementation.
							</p>

							<p>
								<strong>ENDODONTICS (ROOT CANAL):</strong> I understand there is no guarantee that a root canal treatment will save a tooth & that
								complications can occur from the treatment & that occasionally root canal filling material may extend through the tooth
								which does not necessarily effect the success of the treatment. I understand that endodontics files & drills are very fine
								instruments & stresses vanted in their manufacture & calcifications present in teeth can cause them to break during use. I
								understand that referral to the endodontist for additional treatments may be necessary following any root canal treatment &
								I agree that I am responsible for any additional cost for treatment performed by the endodontist. I understand that a tooth
								may required removal in spite of all efforts to save it.
							</p>

							<p>
								<strong>PERIODONTAL DISEASE:</strong> I understand that periodontal disease is a serious condition causing gum & bone inflammation
								&/or loss & that can lead eventually to the loss of my teeth. I understand the alternative treatment plans to correct periodontal disease, including gum surgery tooth extractions with or without replacement. I understand that undertaking any
								dental procedures may have future adverse effect on my periodontal conditions.
							</p>

							<p>
								<strong>FILLINGS:</strong> I understand that care must be exercised in chewing on fillings, especially during the first 24 hours to avoid
								breakage. I understand that a more extensive filling or a crown may be required, as additional decay or fracture may
								become evident after initial exacavation. I understand that significant sensitivity is a common, but usually temporary, aftereffect
								of a newly place filling. I further understand that filling a tooth may irritate the nerve tissue creating sensitivity &
								treating such sensitivity could require root canal theraphy or extractions.
							</p>

							<p>
								<strong>DENTURES:</strong> I understand that wearing of dentures can be difficult. Sore spots, altered speech & difficulty in eating are
								common problems. Immediate dentures (placement of denture immediately after extractions) may be painful. Immediate
								dentures may require considerable adjusting & several relines. I understand that it is my responsibility to return for delivery
								of dentures. I understand that failure to keep my delivery appointment may result in poorly fitted dentures. If a remake is
								required due to my delays of more than 30 days, there will be additional charges. A permanent reline will be needed later,
								which is not included in the initial fee. I understand that all adjustment or alteration of any kinds this initial period is subject
								to charges.
							</p>

							<p>
								<strong>
									I understand that dentistry is not an exact science and that no dentist can properly guarantee accurate results
									all the time.
								</strong>
							</p>

							<p>
								I hereby authorize any of the doctors/dental auxiliaries to proceed with perform the dental restoration & treatments as
								explained to me. I understand that these are subject to modification depending on undiagnosed circumstances that may
								arise during the course of treatment. I understand that regardless of any dental insurance coverage I may have, I am
								responsible for payment of dental fees, I agree to pay any attorney's fees, collection fee, or court costs that may be incurred
								to satisfy any obligation to this office. All treatment were properly explained to me & any untoward circumstances that may
								arise during the procedure, the attending dentist will no be held liable since it is my free will, with full trust & confidence in
								him/her, to undergo dental treatment under his/her care.
							</p>
						</div>

						<h2 style={{}}>Data Consent Form</h2>
						<div className="terms" style={{ width: '100%', height: '250px', overflowY: 'scroll', border: '1px solid #ddd', padding: '20px 10px' }}>
							<p>The undersigned patient acknowledges that this Clinic and its Practitioners may need to use the information provided by the Patient, take photographs or videos to document the consultations, procedures and treatments administered to assist the Practitioners and to properly evaluate the Patient’s progress. </p>

							<p>The Patient consents and authorizes this Clinic and its Practitioners to take pictures and videos of all the areas of concern on the person’s body and the responsible use of all information provided by the patient during, before and after consultation or treatment. </p>

							<p>The Patient understands that in the event any information, pictures or videos of the patient will be used for any reasons other than to be stored as Medical Records, their face and other identifying marks including security sensitive information (such home address and contact details) will not be shown and will be kept confidential. </p>

							<p>The Patient likewise understands that the patient shall not receive any compensation for the use of the said information, photos and videos.</p>

							<p>The patient has read and understands the Content of this Consent Form and is executing the same freely and voluntary.</p>
						</div>

			            <div className="form-group">
			            	<div className="row">
			            		<div className="col-md-12">
			            			<Checkbox name="consent" id="consentId" label="Patient's Consent" value="1" key={1} index={1} onchange={this.onCheckConsent} checkedItems={[]} />
			            		</div>
			            	</div>
			            </div>
			            <div className="form-group">
			            	<div className="row">
			            		<div className="col-md-3">
			            			<div className="container-fluid">
			            				<img src={this.state.signatureSource} className="img-responsive" />
			            			</div>
			            		</div>
			            	</div>
			            </div>
		            </div>
		            
		            :
		            
		            null
	            }

                <div className="margiv-top-10 text-right">
                    <a href="#" id="savePatientInfoButton" className="btn blue" onClick={this.clickHandler} > Save </a>
                </div>
            </form>

            <div id="signatureModal" className="modal fade in" tabIndex="-1" aria-hidden="true">
				<div className="modal-content">
					<h4 className="modal-title"></h4>
				</div>
				<div className="modal-body">
                    <div id="signature_pad-body-mic" style={{boxShadow: '0px 0px 4px #ddd inset'}}>
                    	<canvas></canvas>
                    </div>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn dark btn-outline" onClick={this.onClearSignature}>
                        Clear
                    </button>
                    <button type="button" className="btn blue" onClick={this.onSaveSignature}>
                        Save
                    </button>
                </div>
			</div>

            </div>
		)
	}

}


/** WEBPACK FOOTER **
 ** ./src/components/patient/PatientInfo.js
 **/